import React, { useState } from 'react';

const AddNodeModal = ({ isOpen, onClose, availableNodes = [], onAdd }) => {
  const [selectedId, setSelectedId] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedId) return alert("Please select a data point.");
    
    const item = availableNodes.find(n => n.id === selectedId);
    if (item) {
      onAdd(item, item.matrixType || 'Artifact');
      setSelectedId('');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] p-4 backdrop-blur-sm">
      <div className="bg-[#0a0a0a] border border-gray-800 p-6 w-full max-w-md rounded shadow-2xl flex flex-col gap-4">
        <h3 className="text-white font-bold uppercase tracking-widest border-b border-gray-900 pb-2">Add Data Node</h3>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="text-[10px] text-gray-500 uppercase tracking-widest font-bold mb-2 block">Select Record</label>
            <select 
              className="w-full bg-black border border-gray-800 text-white p-3 text-xs outline-none focus:border-white transition-colors" 
              value={selectedId} 
              onChange={e => setSelectedId(e.target.value)}
            >
              <option value="">-- SELECT DATA POINT --</option>
              {availableNodes.map(n => (
                <option key={n.id} value={n.id}>[{n.matrixType ? n.matrixType.toUpperCase() : 'UNKNOWN'}] {n.title || n.name}</option>
              ))}
            </select>
          </div>
          <div className="flex gap-2 mt-4 pt-4 border-t border-gray-900">
            <button type="button" onClick={onClose} className="flex-1 p-3 text-gray-500 text-xs font-bold uppercase tracking-widest hover:text-white transition-colors">Cancel</button>
            <button type="submit" className="flex-1 bg-gray-900 border border-gray-700 text-white text-xs font-bold uppercase tracking-widest hover:bg-gray-700 transition-colors">Add To Canvas</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNodeModal;